import React, { useState } from 'react';
import './Medicalinstrum.css';
import medicinst1 from '../../../imgs/medicinst1.webp';
import medicinst2 from '../../../imgs/medicinst2.webp';
import medicinst3 from '../../../imgs/medicinst3.webp';
import medicinst4 from '../../../imgs/medicinst4.webp';
import Reqprodcte from "../../../components/Reqprodcte";


const images = [
    { src: medicinst1 },
    { src: medicinst2 },
    { src: medicinst3 },
    { src: medicinst4 },
];

const Medicalinstrum = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="fittinginj-main-container">

            <div className="fittinginj-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"} data-aos="fade-down" key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image" />
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots"data-aos="fade-down">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            <div className="fittinginj-text">
                <h2>Medical Instrument Injection Molding Machine</h2>
                <h3>KE SERIES</h3>
                <p>
                    Dishatech Medical Instrument Injection Molding Machine are specialized for manufacturing medical instrument like: syringe, blood collection tubes, infusion parts and so on. Machines parts are covered to prevent contamination.                </p>
                <ul>
                    <li><strong>Clamping Force:</strong> –  258(Ton)</li>
                    <li><strong>Applications :</strong> - Medical Instrument Products</li>
                </ul>
            <div className='stnd'>
                    <Reqprodcte />
                </div>
            </div>
        </div>
    );
};
export default Medicalinstrum;
